import * as React from 'react';
import Popper from '@mui/material/Popper';
import { useAxisTooltip, useMouseTracker } from '@mui/x-charts/ChartsTooltip';
import { useDrawingArea, useSvgRef } from '@mui/x-charts/hooks';

import { generateVirtualElement } from 'ff/debrief/components/charts/utils';
import CustomTooltipContent from './CustomTooltipContent';

interface Props {
    boundaryEl: React.RefObject<Element>;
}

export function CustomTooltip(props: React.PropsWithChildren<Props>) {
    const tooltipData = useAxisTooltip();
    const mousePosition = useMouseTracker();
    const svgRef = useSvgRef(); // Get the ref of the <svg/> component.
    const drawingArea = useDrawingArea(); // Get the dimensions of the chart inside the <svg/>.
    const tooltipContentRef = React.useRef<HTMLDivElement>(null);

    if (!tooltipData || !mousePosition || !svgRef.current) {
        // No data to display
        return null;
    }

    const tooltipPosition = {
        x: mousePosition.x,
        y: svgRef.current.getBoundingClientRect().top + drawingArea.top,
    };

    return (
        <Popper
            sx={{
                pointerEvents: 'none',
                zIndex: theme => theme.zIndex.modal,
            }}
            modifiers={[
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: props.boundaryEl.current,
                        tether: false,
                    },
                },
            ]}
            open
            placement="top"
            anchorEl={generateVirtualElement(tooltipPosition)}
        >
            <CustomTooltipContent ref={tooltipContentRef} {...tooltipData} />
        </Popper>
    );
}

export default CustomTooltip;
